import * as React from 'react';
const SvgVideoGameController = props => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlSpace='preserve' width={800} height={800} viewBox='0 0 32 32' {...props}>
    <path d='M17 10V6h-2v4H2v16h28V10H17zm11 14H4V12h24v12z' />
    <path d='M9 22h2v-3h3v-2h-3v-3H9v3H6v2h3zM18 17h2v2h-2zM24 17h2v2h-2zM21 14h2v2h-2zM21 20h2v2h-2z' />
  </svg>
);
export default SvgVideoGameController;
